var SCM = SCM || {};

SCM.SplitScreenContentsToc = (function (ns, elementManager, splitScreenHelper) {

    return {
        handleJumpLinks: handleJumpLinks,
        setDataSectionTypeForJumpLinks: setDataSectionTypeForJumpLinks,
        highlightSectionTitle: highlightSectionTitle,
    };

    function handleJumpLinks(elem, widgets) {
        var offset = 50;
        var location = elem.attributes['href'].textContent.substring(1);
        if ('sectionType' in elem.dataset) {
            if (elem.dataset.sectionType.indexOf('js-splitscreen-backreferences-title') !== -1 ||
                elem.dataset.sectionType.indexOf('js-splitscreen-reference-target') !== -1) {
                widgets.ReferencesTab.switchTo();
                return;
            }

            if (elem.dataset.sectionType.indexOf('backnotes-title') !== -1 ||
                elem.dataset.sectionType.indexOf('js-splitscreen-backfootnotegroup-title') !== -1 ||
                elem.dataset.sectionType.indexOf('js-footnotes-target') !== -1 ||
                elem.dataset.sectionType.indexOf('js-end-notes-target') !== -1) {

                var targetClasses = elem.dataset.sectionType.split(' ');
                var target = elementManager.getElementsByClassList(widgets.NotesTab, targetClasses);

                widgets.NotesTab.switchTo();
                widgets.NotesTab.scrollTop = 0;
                widgets.NotesTab.scrollTop = $(target).offset().top - offset;

                return;
            }
        }
        var section = document.getElementById(location);
        if (section) {
            var scrollablePanel = widgets.Content;
            // Offset needs to be relative to the parent (scrollable panel),
            // so we don't need to worry about the sticky toolbar
            scrollablePanel.scrollTop = section.offsetTop;
        }
    }

    function getJumpLinks(contentsTab) {
        var map = {};
        var links = elementManager.getElementsByClass(contentsTab, 'js-jumplink');
        for (var i = 0; i < links.length; i++) {
            var linkHref = links[i].href;
            if (linkHref.indexOf('#') < 0) continue;
            var id = linkHref.split('#').slice(-1);
            map[id] = links[i];
        }

        return map;
    }

    function getJumpLinkTargets(content, jumpLinks) {
        var sectionTitles;

        if (splitScreenHelper.isArticlePage()) {
            sectionTitles = Array.prototype.concat(
                Array.prototype.slice.call(content.getElementsByTagName('h2'), 0),
                Array.prototype.slice.call(content.getElementsByTagName('h3'), 0)).sort(elementManager.elementComparator);
        } else {
            sectionTitles = elementManager.getElementsByClass(content, 'jumpLoc-sectionId');
        }

        for (var i = 0; i < sectionTitles.length; i++) {
            if (!jumpLinks[sectionTitles[i].id]) {
                sectionTitles.splice(i, 1);
                i--;
            }
        }
        return sectionTitles;
    }

    function setDataSectionTypeForJumpLinks(ContentFullText, ContentJumpLinks) {
        var fragment = document.createDocumentFragment();
        fragment.appendChild(ContentFullText);

        var jumpLinks = ContentJumpLinks.getElementsByClassName('js-jumplink');
        for (var i = 0; i < jumpLinks.length; i++) {
            var jumpLink = jumpLinks[i];
            var location = jumpLink.attributes['href'].textContent.substring(1);

            // need to do chapter end notes differently since it's outside ContentFullText
            if (location == 'endNotesTargetLocation-sv') {
                var endNotes = elementManager.getFirstElementByClassName(document, 'js-end-notes-target');
                jumpLink.dataset.sectionType = endNotes.className;
            }

            var section = fragment.querySelector("[id='" + location + "']");
            if (section) {
                jumpLink.dataset.sectionType = section.className;
            }
        }
    }

    function removeHighlightFromChapterNoteHeaders(ContentsTab) {
        $(ContentsTab).find('.js-notes-link-end-notes, .js-notes-link-chapter-footnotes')
                      .removeClass('active');
    }

    function highlightSectionTitle(widgets) {
        var tippieTop = widgets.Content.scrollTop;
        var jumpLinks = getJumpLinks(widgets.ContentsTab);
        var sectionTitles = getJumpLinkTargets(widgets.Content, jumpLinks);

        // Remove any existing highlighting for the jumplinks
        for (var id in jumpLinks) {
            elementManager.elementRemoveClass(jumpLinks[id], 'active');
            elementManager.elementRemoveClass(jumpLinks[id], 'at-highlighted-heading');
        }

        // Remove standard view current node and set tabindex for tree to -1
        $('.tocLink[aria-current]').removeAttr('aria-current');
        $('.js-jumplink-list[role="tree"] .js-nav-tree-link').attr('tabindex', '-1');

        // Chapter endNotes aren't found in getJumpLinks, so they need to be handled separately
        removeHighlightFromChapterNoteHeaders(widgets.ContentsTab);

        for (var i = sectionTitles.length - 1; i >= 0; i--) {
            var top = sectionTitles[i].offsetTop;

            if (top <= tippieTop) {
                var link = jumpLinks[sectionTitles[i].id];
                elementManager.elementAddClass(link || jumpLinks[sectionTitles[0]], 'active');
                elementManager.elementAddClass(link || jumpLinks[sectionTitles[0]], 'at-highlighted-heading');
                $(link || jumpLinks[sectionTitles[0]]).attr('aria-current', 'true');
                $(link || jumpLinks[sectionTitles[0]]).attr('tabindex', '0');
                return;
            }
        }
    }

})(SCM.SplitScreenContentsToc = SCM.SplitScreenContentsToc || {}, SCM.ElementManager, SCM.SplitScreenHelper);